// @ts-nocheck
import { useEffect, useState } from 'react';
import './App.css';
import Navbar from './Components/Navbar'
import Banner from './Components/Banner';
import Services from './Components/Services';
import About from './Components/About';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import Loading from './Components/Loading'
import Error from './Components/Error';

// Parses the JSON returned by a network request
const parseJSON = (resp) => (resp.json ? resp.json() : resp);

// Checks if a network request came back fine, and throws an error if not
const checkStatus = (resp) => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp) => {
    throw resp;
  });
};

export const baseUrl = "https://api.tairi.ee";

//for local dev
// const base_url = "http://localhost:1337"

const headers = { "Content-Type": "application/json" };
const ehitusApiUrl = baseUrl + "/api/ehitus?populate=*&populate=menu.logo&populate=banner.banneri_pilt&populate=teenused&populate=meist.pilt&populate=kontakt&populate=jalus&populate=metadata"
const kunstApiUrl = baseUrl + "/api/kunst?populate=*&populate=menu.logo&populate=banner.banneri_pilt&populate=tingimused&populate=meist.pilt&populate=kontakt&populate=jalus&populate=metadata"



const App = () => {
  const [error, setError] = useState(null);
  const [strapiData, setStrapiData] = useState([]);

  let strapiApiUrl = ehitusApiUrl
  if (window.location.href.indexOf("kunst") > -1) {
    const root = document.getElementById("root")
    root.className = "art"
    strapiApiUrl = kunstApiUrl
  }

  useEffect(() => {
    fetch(strapiApiUrl, { headers, method: "GET" })
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setStrapiData(data.attributes))
      .catch((error) => setError(error));
  }, [strapiApiUrl]);

  if (error) {
    // Print errors if any
    console.log(error.message)
    return <Error/>;
  }

  if (!strapiData.menu) {
    return <Loading/>
  }

  if (strapiData.metadata) {
    document.title = strapiData.metadata.pealkiri
    document.querySelector('meta[name="description"]').setAttribute("content", strapiData.metadata.kirjeldus);
  }

  return (
    <>
      {strapiData.menu && <Navbar content={strapiData.menu} />}
      {strapiData.banner && <Banner content={strapiData.banner} />}
      {strapiData.teenused && <Services content={strapiData.teenused} />}
      {strapiData.tingimused && <Services content={strapiData.tingimused} />}
      {strapiData.meist && <About content={strapiData.meist} />}
      {strapiData.kontakt && <Contact content={strapiData.kontakt} />}
      {strapiData.jalus && <Footer content={strapiData.jalus} />}
    </>
  );
};

export default App;
